import { DOCUMENT_TYPE_UNCLASSIFIED } from '@klear/constants/document-types'
import type { DocumentListRow } from '@klear/document/trader-document'
import { Card, CardContent, CardHeader, CardTitle } from '@klear/ui/components/card'
import { trpc } from '@klear/ui/lib/trpc'
import { addedOn, captionOf, FileActions, typeLabel, WhereCell } from '@/app/documents/document-row'

function PaymentDocumentRow({ detail, paymentId }: { detail: DocumentListRow; paymentId: number }) {
  const { document } = detail
  const caption = captionOf(detail)
  const elsewhere = document.references.filter(
    (reference) => !(reference.kind === 'payment' && reference.id === paymentId)
  )
  const meta = [
    ...(document.type === DOCUMENT_TYPE_UNCLASSIFIED ? [] : [typeLabel(document)]),
    `Added ${addedOn(document)}`
  ].join(' · ')
  return (
    <li className="flex items-start justify-between gap-4 py-2">
      <div className="min-w-0">
        <div className="truncate font-medium" title={document.name}>
          {document.name}
        </div>
        {caption !== undefined && (
          <div className="text-muted-foreground truncate text-xs" title={caption}>
            {caption}
          </div>
        )}
        <div className="text-muted-foreground mt-0.5 text-xs">{meta}</div>
        <WhereCell detail={detail} references={elsewhere} empty={null} className="mt-1 text-xs" />
      </div>
      <div className="shrink-0">
        <FileActions document={document} />
      </div>
    </li>
  )
}

export function PaymentDocuments({ paymentId }: { paymentId: number }) {
  const { data, isLoading } = trpc.documents.list.useQuery({ filedOn: { kind: 'payment', id: paymentId } })
  const rows = data?.rows ?? []
  return (
    <Card>
      <CardHeader>
        <CardTitle>Documents</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="text-muted-foreground text-sm">Loading documents...</div>
        ) : rows.length === 0 ? (
          <div className="text-muted-foreground text-sm">No documents on this payment.</div>
        ) : (
          <ul className="divide-y">
            {rows.map((detail) => (
              <PaymentDocumentRow key={detail.document.id} detail={detail} paymentId={paymentId} />
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  )
}
